import './Clinic.css';
import Navbar from '../Navbar/Navbar';
import '../../assets/css/style.css';
import brainBg1 from '../../assets/img/clinic//1.png';
import brainBg2 from '../../assets/img/clinic//2.png';
import { useState, useEffect } from 'react';
import hitakrilogo from '../../assets/img/hitakrilogo.png';


const Neurology = () => {
     const [currentImageIndex, setCurrentImageIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
          setCurrentImageIndex((prevIndex) => (prevIndex + 1) % 2);
        }, 4000);

        return () => clearInterval(interval);
      }, []);

    const images = [brainBg1, brainBg2];
     const backgroundImage = images[currentImageIndex];
    return (
        <>
        <div className="main-wrapper">
            <header className="header">
                <Navbar />
            </header>

            {/* Breadcrumb */}
            <div className="breadcrumb-bar">
                <div className="container-fluid">
                    <div className="row align-items-center">
                        <div className="col-md-12 col-12">
                            <nav aria-label="breadcrumb" className="page-breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                                    <li className="breadcrumb-item"><a href="/clinic-and-specialities">Our Specialized Medical Departments</a></li>
                                    <li className="breadcrumb-item active" aria-current="page">Neurology</li>
                                </ol>
                            </nav>
                            <h2 className="breadcrumb-title">Neurology</h2>
                        </div>
                    </div>
                </div>
            </div>
            {/* /Breadcrumb */} 

            <div className="content">
              {/* Full-Width Background with Minimal Text */}
                           <div className="urology-header" style={{ backgroundImage: `url(${backgroundImage})` }}>
                                <div className="urology-overlay">
                                    <div className="urology-header-content">
                                    <p>
                                       <br />
                                         <strong>Neurology Department at Hitkari Hospital</strong>
                                          </p>

                                    </div>
                                </div>
                            </div>
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                           
                             <div className="terms-content">
                                <div className="terms-text">
                                     <h3>Neurology Department at Hitkari Hospital</h3>
                                       <p>The Neurology Department at Hitkari Hospital is committed to providing world-class care for the diagnosis, treatment, and management of neurological disorders. Equipped with advanced medical technologies and staffed by a team of highly skilled neurologists, neurophysiologists, and rehabilitation specialists, we offer a comprehensive approach to addressing complex neurological conditions. Our goal is to enhance the quality of life for patients through accurate diagnoses, personalized treatments, and compassionate care.</p>
                                </div>
                                <div className="terms-text">
                                    <h3>Services Offered by the Neurology Department</h3>
                                    <h4>1. Diagnosis and Management of Neurological Disorders</h4>
                                    <ul>
                                        <li>Stroke Management: Immediate treatment for ischemic and hemorrhagic strokes, including thrombolysis and neurointerventional procedures.</li>
                                        <li>Epilepsy Care: Comprehensive evaluation and management of epilepsy, including EEG monitoring and advanced treatment plans for drug-resistant epilepsy.</li>
                                        <li>Headache and Migraine Treatment: Tailored therapies to alleviate and manage chronic headaches and migraines.</li>
                                        <li>Movement Disorders: Specialized care for Parkinson’s disease, dystonia, tremors, and other movement-related conditions.</li>
                                        <li>Neuromuscular Disorders: Diagnosis and treatment of conditions affecting muscles and nerves, such as myasthenia gravis and peripheral neuropathies.</li>
                                    </ul>
                                </div>
                                 <div className="terms-text">
                                       <h4>2. Neurodiagnostic Services</h4>
                                        <ul>
                                            <li>Electroencephalography (EEG): Real-time monitoring to detect abnormal brain activity in conditions like epilepsy.</li>
                                            <li>Electromyography (EMG): Assessing muscle function and nerve conduction to identify neuromuscular disorders.</li>
                                            <li>Advanced Imaging: MRI, CT scans, and angiography for precise visualization of brain and spinal cord abnormalities.</li>
                                            <li>Evoked Potential Studies: Evaluating sensory and motor pathway integrity in the nervous system.</li>
                                        </ul>
                                </div>
                                 <div className="terms-text">
                                      <h4>3. Neurointerventional Services</h4>
                                      <ul>
                                            <li>Endovascular Treatments: Minimally invasive procedures for aneurysms, AV malformations, and carotid artery disease.</li>
                                             <li>Mechanical Thrombectomy: Life-saving interventions to remove blood clots during acute strokes.</li>
                                            <li>Spinal Injections and Nerve Blocks: Pain management for conditions like sciatica and herniated discs.</li>
                                        </ul>
                                 </div>
                                   <div className="terms-text">
                                       <h4>4. Pediatric Neurology</h4>
                                        <ul>
                                            <li>Developmental Delay and Autism Spectrum Disorder (ASD) Management: Comprehensive care and therapeutic strategies.</li>
                                            <li>Cerebral Palsy Management: Multidisciplinary interventions for children with motor disorders.</li>
                                             <li>Seizure Disorders in Children: Accurate diagnosis and age-appropriate treatments.</li>
                                        </ul>
                                </div>
                                 <div className="terms-text">
                                         <h4>5. Neurorehabilitation</h4>
                                       <ul>
                                          <li>Stroke Rehabilitation: Tailored therapy programs to restore mobility, speech, and independence.</li>
                                           <li>Cognitive Rehabilitation: Assisting patients with memory, attention, and problem-solving difficulties.</li>
                                           <li>Physiotherapy and Occupational Therapy: Improving physical function and daily living activities for neurological patients.</li>
                                       </ul>
                                 </div>
                                 <div className="terms-text">
                                         <h4>6. Neurocritical Care</h4>
                                       <ul>
                                            <li>Comprehensive ICU Care: Advanced monitoring and treatment for critically ill neurological patients, including those with traumatic brain injuries and severe strokes.</li>
                                            <li>Seizure Emergencies: Rapid response and intensive management of status epilepticus.</li>
                                             <li>Neurotrauma Care: Expertise in managing head and spinal injuries with a focus on minimizing long-term damage.</li>
                                       </ul>
                                 </div>
                                  <div className="terms-text">
                                    <h3>Why Choose the Neurology Department at Hitkari Hospital?</h3>
                                      <ul>
                                           <li>Advanced Technology: State-of-the-art neurodiagnostic tools and imaging systems for accurate and timely diagnosis.</li>
                                           <li>Expert Team: Experienced neurologists, neurosurgeons, and neuro-rehabilitation specialists dedicated to holistic care.</li>
                                            <li>Comprehensive Care: From preventive strategies to post-treatment rehabilitation, we ensure every aspect of neurological health is addressed.</li>
                                            <li>Patient-Centric Approach: Personalized treatment plans designed to suit individual needs and enhance recovery outcomes.</li>
                                           <li>Multidisciplinary Collaboration: Seamless integration with other departments for managing complex neurological cases.</li>
                                      </ul>
                                </div>
                                 <div className="terms-text">
                                    <p>At Hitkari Hospital, we are devoted to delivering exceptional neurological care with a focus on precision, innovation, and empathy. Whether managing chronic conditions or addressing critical neurological emergencies, our team ensures that every patient receives the best possible care for a healthier and more fulfilling life.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <footer className="footer">
            {/* Footer Top */}
            <div className="footer-top">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-3 col-md-6">
                            <div className="footer-widget footer-about">
                                <div className="footer-logo">
                                    <img src={hitakrilogo} alt="Hitkari Hospital Logo" className="footer-logo-img" style={{ backgroundColor: '#4b8cd681' }} />
                                </div>
                                <div className="footer-about-content">
                                    <p>Your health is our priority. Combining advanced care with a personal touch, our expert team is dedicated to supporting your journey to better health.</p>
                                    <div className="social-icon">
                                        <ul>
                                            <li><a href="https://www.facebook.com/p/Hitkari-Hospital-100063931666732/" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook-f"></i></a></li>
                                            <li><a href="https://www.instagram.com/hitkarihospital/" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div className="footer-widget footer-menu">
                                <h2 className="footer-title">For Patients</h2>
                                <ul>
                                    <li><a href="/"><i className="fas fa-angle-double-right"></i> Search for Doctors</a></li>
                                    <li><a href="/privacypolicy"><i className="fas fa-angle-double-right"></i> Privacy-Policy</a></li>
                                    <li><a href="/terms"><i className="fas fa-angle-double-right"></i> Terms-Conditions</a></li>
                                    <li><a href="/booking"><i className="fas fa-angle-double-right"></i> Booking</a></li>
                                    <li><a href="/"><i className="fas fa-angle-double-right"></i> Patient Dashboard</a></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div className="footer-widget footer-menu">
                                <h2 className="footer-title"
                                >
                                    For Patients
                                </h2>
                                <ul>
                                    <li><a href="/appointments"><i className="fas fa-angle-double-right"></i> Appointments</a></li>
                                    <li><a href="/gallery"><i className="fas fa-angle-double-right"></i> Gallery</a></li>
                                    <li><a href="/services"><i className="fas fa-angle-double-right"></i> Services</a></li>
                                    <li><a href="/"><i className="fas fa-angle-double-right"></i> Doctor Dashboard</a></li>
                                    <li><a href="/blogs"><i className="fas fa-angle-double-right"></i> Blogs</a></li>
                                </ul>
                            </div>
                        </div>

                        <div className="col-lg-3 col-md-6">
                            <div className="footer-widget footer-contact">
                                <h2 className="footer-title">Contact Us</h2>
                                <div className="footer-contact-info" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>
                                    <div className="footer-address" style={{ display: 'flex', alignItems: 'flex-start' }}>
                                        <a href="https://www.google.com/maps?q=NEAR+MTM+SCHOOL,+BALOTRA" target="_blank" rel="noopener noreferrer" style={{ display: 'flex', textDecoration: 'none', color: 'inherit', alignItems: 'flex-start' }}>
                                            <i className="fas fa-map-marker-alt" style={{ marginRight: '5px' }}></i>
                                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                <span>Neelam Cinema Ke Pass, BALOTRA,</span>
                                                <span>DISTT.- BARMER ( RAJASTHAN ),</span>
                                                <span>PIN – 344022</span>
                                            </div>
                                        </a>
                                    </div>
                                    <p style={{ display: 'flex', alignItems: 'center', margin: 0 }}>
                                        <a href="tel:02988223100" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', color: 'inherit',marginTop:'18px' }}>
                                            <i className="fas fa fa-phone" style={{ marginRight: '5px' }}></i>
                                            02988-223100
                                        </a>
                                    </p>
                                    <p style={{ display: 'flex', alignItems: 'center', margin: 0 }}>
                                        <a href="mailto:hitkarihospitalblt2015@gmail.com" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', color: 'inherit', marginTop:'18px' }}>
                                            <i className="fas fa-envelope" style={{ marginRight: '5px' }}></i>
                                            hitkarihospitalblt2015@gmail.com
                                        </a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="footer-bottom">
                <div className="container-fluid">
                    <div className="copyright">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="copyright-text">
                                    <p className="mb-0">
                                        <a href="/" style={{ color: 'white', textDecoration: 'none' }}>@ Copyright Hitkari Hospital, All rights reserved.</a>
                                    </p>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="copyright-menu">
                                    <ul className="policy-menu">
                                        <li><a href="https://dheersoftwaresolutions.com/" style={{ color: 'white', textDecoration: 'underline', marginRight:'132px' }} target="_blank" rel="noopener noreferrer">Developed By ,Dheer Software Solutions</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
        </>
    );
};

export default Neurology;